import ControlsClose from "@workspace/casino_pages/legacyLayer/external/icons/ControlsClose";
import Button from "@workspace/casino_pages/legacyLayer/legacyUi/Button";

type Props = {
  onClose: () => void;
};

const CloseButton: FC<Props> = ({ onClose }) => (
  <Button
    className="absolute top-2 float-right cursor-pointer justify-self-end border-none bg-transparent "
    onClick={onClose}
  >
    <ControlsClose className="text-background" fontSize={24} />
  </Button>
);

export default CloseButton;
